import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Authorization } from '@/src/lib/authorization/authorization';
import { RootState } from '@/src/reducers/types';

const Item = ({ project, onClick, menu, activeMenu }) => {
  const navClasses = clsx(
    'tw-block',
    'tw-w-full',
    'tw-py-[10px] tw-px-[30px]',
    'tw-text-cfo-black',
    '!tw-no-underline'
  );

  // checks if the child of a parent Nav is active
  const isChildActive = menu.children.some((c) => c.id === activeMenu.id);

  return (
    <li>
      <NavLink
        to={`/projects/${project.Selected.id}/settings${menu.path}`}
        isActive={() => activeMenu.id === menu.id && isChildActive}
        onClick={(e) => onClick(e, menu)}
        className={clsx(
          navClasses,
          (activeMenu.id === menu.id || isChildActive) &&
            'active tw-bg-[#E5ECFF] !tw-text-cfo-blue-600 tw-font-brandonTextMedium',
          'hover:tw-bg-[#E5ECFF] hover:tw-text-cfo-blue-600 hover:tw-font-brandonTextMedium'
        )}
      >
        {menu.label}
      </NavLink>
      {menu.children.length > 0 && (
        <ul className={clsx('tw-p-0', 'tw-list-none')}>
          {menu.children.map((c) => (
            <Authorization allowedRoles={c.allowedRoles} key={c.id}>
              <li key={c.id}>
                <NavLink
                  to={`/projects/${project.Selected.id}/settings${menu.path}/#${c.id}`}
                  isActive={() => false}
                  onClick={(e) => onClick(e, c)}
                  className={clsx(
                    navClasses,
                    '!tw-pl-[50px]',
                    activeMenu.id === c.id &&
                      'active tw-bg-[#E5ECFF] !tw-text-cfo-blue-600 tw-font-brandonTextMedium'
                  )}
                >
                  {c.label}
                </NavLink>
              </li>
            </Authorization>
          ))}
        </ul>
      )}
    </li>
  );
};

const Settings = (props) => {
  const project = useSelector((state: RootState) => state.project);

  const handleClick = (e, c) => {
    props.onUpdateSidebar(c);
  };

  return (
    <div
      className={clsx(
        // 'settingsSidebar',
        'settingsSidebar--container',
        'tw-max-w-[293px] tw-w-full',
        'tw-pt-[20px]',
        'tw-bg-white',
        'tw-border-solid tw-border-r-[1px] tw-border-cfo-grey-500'
      )}
    >
      <ul className={clsx('tw-p-0', 'tw-list-none')}>
        {props.menus.map((menu) => {
          return (
            <Authorization allowedRoles={menu.allowedRoles} key={menu.id}>
              <Item
                onClick={handleClick}
                project={project}
                menu={menu}
                // isActive={isActive}
                activeMenu={props.activeMenu}
              />
            </Authorization>
          );
        })}
      </ul>
    </div>
  );
};

export default Settings;
